import { useSelector } from 'react-redux';
export var GetRippleRoles = function GetRippleRoles() {
  var childRoles = [];
  var visibleRoles = useSelector(function (data) {
    return data.auth.user && data.auth.user.roles && data.auth.user.roles.map(function (r) {
      if (r && r.childRoles && r.childRoles.length) {
        childRoles.push(r.childRoles.map(function (c) {
          return c.name;
        }));
      }

      return r.name ? r.name : '';
    });
  });
  return visibleRoles && visibleRoles.length ? [].concat(childRoles, visibleRoles.map(function (c) {
    return c;
  })).flat().map(function (c) {
    return c;
  }) : [];
};
export var areRolesAuthorized = function areRolesAuthorized(rippleRoles, component, supportedMethods) {
  var componentRoles = rippleRoles.filter(function (r) {
    return r.includes(component) && r.includes('_');
  });
  var rolesMethods = componentRoles.map(function (c) {
    return c.split('_', 2)[1];
  });
  return supportedMethods.some(function (s) {
    return rolesMethods.map(function (a) {
      return a === s;
    }).includes(true);
  });
};